import { render, staticRenderFns } from "./EmbedMe.vue?vue&type=template&id=390ce41c"
import script from "./EmbedMe.vue?vue&type=script&lang=js"
export * from "./EmbedMe.vue?vue&type=script&lang=js"
import style0 from "./EmbedMe.vue?vue&type=style&index=0&id=390ce41c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports